import { createContext } from "react";

export type StandardMeetingsPanelStatus = "closed" | "idle" | "submitting";

export interface StandardMeetingsPanelContextProps {
  status: StandardMeetingsPanelStatus;
  isOpen: boolean;
  templateId: number | undefined;
  isSubmitting: boolean;
  showStandardMeetingsPanel: () => void;
  closeStandardMeetingsPanel: () => void;
  setTemplateId: (id: number | undefined) => void;
  handleSubmit: () => Promise<void>;
  canSubmit: () => boolean;
}

export const StandardMeetingsPanelContext = createContext({} as StandardMeetingsPanelContextProps);
